import {
    FETCH_PROMPT_KEYS_SUCCESS,
    FETCH_PROMPT_BY_KEY_SUCCESS,
    PROMPTS_REQUEST_LOADING,
    PROMPTS_REQUEST_ERRORS
} from "api/menu/hr/prompts/actions";

const initialState = {
    loading: false,
    errors: [],
    promptKeys: [],
    selectedPrompt: {}
};

export default function(state = initialState, action) {
    switch (action.type) {
        case PROMPTS_REQUEST_LOADING:
            return { ...state, loading: true };
        case PROMPTS_REQUEST_ERRORS:
            return { ...state, loading: false, errors: action.payload };
        case FETCH_PROMPT_KEYS_SUCCESS:
            return { ...state, loading: false, promptKeys: action.payload };
        case FETCH_PROMPT_BY_KEY_SUCCESS:
            return { ...state, loading: false, selectedPrompt: action.payload };
        default:
            return state;
    }
}
